(function() {
    'use strict';

a3_cabin_reports.controller('SafetyCtrl', SafetyCtrl);

function SafetyCtrl($scope,operationalPhases,$timeout, $routeParams, FlightFactory, $location, SafetyReportFactory){
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);

    $scope.flight = flight;
    $scope.operationalPhases = angular.fromJson(operationalPhases);

    $scope.responseMessage = "";
    $scope.showPanel = "submit";

    $scope.formData = {
        flightId: $routeParams.flightId,
        flightNo: flight.FlightNo,
        flightDate: flight.ScheduledDeparture,
        flightDep:flight.Departure,
        flightArr: flight.Arrival,
        flightRegistration: flight.AcTailNo,
        occurenceTitle: "",
        description: "",
        selectedPhase: "",
        attachedFiles: [],
        isConfidential: false
    };
    $scope.sizeLimitKb = 25000;
    $scope.fileTooLargeMsg = false;
    $scope.fileUploaded = fileUploaded;
    $scope.removeFile = removeFile;
    $scope.isIFileTooLarge = isFileTooLarge;
    $scope.submitForm = submitForm;



    function gotoFlightInfo(flightId){
        $location.path('/flightinfo/' + flightId);
    }

    function submitForm() {
        if ($scope.formCabinReport.$valid) {
           confirmCreateReport();   
           //console.log($scope.formData.attachedFiles);        
        }else {
            bootbox.alert("Please fill in all the required fields.");
        }
    }

    function confirmCreateReport() {
        bootbox.dialog({
            message: "<strong>Would you like to proceed with the Safety Report?</strong><br/><br/>",
            title: "Send Report",
            buttons: {
                 confirm:{
                    label: 'Confirm',
                    className: "btn-success",
                    callback: function(){
                        $scope.showPanel = "loading";
                        SafetyReportFactory.saveSafetyReport($scope.formData)
                        .then(res => handleSubmitResponse(res));
                    }
                },  
                cancel:{
                    label: "Cancel",
                    className: "btn-default",
                    callback: function(){}
                }
            }
        })
    }  

    function handleSubmitResponse(res) {
        var alertStyle = res.success ? "success" : "warning";

        bootbox.dialog({
            message: "<div class='alert alert-"+ alertStyle +"'><strong>" + res.message + " </strong></div>",
            title: "Response Message",
            buttons: {
                cancel:{
                    label: "Close",
                    className: "btn-default",
                    callback: function(){
                        if (res.success) {
                            $timeout(gotoFlightInfo(flightId));
                        }
                        else {
                            $timeout($scope.showPanel = "submit");
                        }
                    }
                }       
            }
        })
        
    }

    function isFileTooLarge(image) {
        var isLarge= false;
        if (image && image.dataURL != null) {
            isLarge = (image.dataURL.length > $scope.sizeLimitKb * 1024);
        }
        return isLarge;
    }

    function fileUploaded(data) {
        var fileResult = data; //$scope.imageBrowsed;
        var uploadedFile = {};


        if (isFileTooLarge(data)) {
            $scope.fileTooLargeMsg = true;
        } else {
            $scope.fileTooLargeMsg = false;
            uploadedFile.fileBlobb = fileResult.dataURL;
            uploadedFile.description = fileResult.fileType || fileResult.file.type;
            uploadedFile.fileName = fileResult.fileName;

            // var files = $scope.formData.attachedFiles;
            if ($scope.formData.attachedFiles.length < 5) {
                // var n = Object.create(attachedFile);
                $scope.formData.attachedFiles.push(uploadedFile);

            } else {
                $scope.showMaxFiles = true;
            }
        }
    }

    function removeFile(attachedFile){
        var files = $scope.formData.attachedFiles;
        var arrayLenght = files.length;
        var itemIndex = -1;
        for (var i = 0; i < arrayLenght; i++) {
            if (files[i].fileName == attachedFile.fileName) {
                itemIndex = i;
                break;
            }
        }
        
        if (itemIndex >= 0) {
            files.splice(itemIndex, 1);

            return attachedFile;
        }
        if($scope.showMaxImages){
            appendPhoto();
        }
        $scope.showMaxImages = false;
    }
 
}
})();